// Import the formatSchedule function
import formatSchedule from './utils/formatSchedule';

// Test data based on your actual database values
const testData = [
  {
    title: "1100 Timing Test", 
    scheduleType: "DAILY",
    scheduleTime: "10:00:00",
    scheduleDay: null,
    scheduleDays: null
  },
  {
    title: "1", 
    scheduleType: "DAILY",
    scheduleTime: "08:00:00",
    scheduleDay: null,
    scheduleDays: null
  },
  {
    title: "First Automation", 
    scheduleType: "DAILY",
    scheduleTime: "12:07:00",
    scheduleDay: null,
    scheduleDays: null
  },
  {
    title: "Botox 90 Days Re-Engagement Campaign", 
    scheduleType: "DAILY",
    scheduleTime: "09:00:00",
    scheduleDay: null,
    scheduleDays: null
  }
];

// Run the tests
console.log("Testing formatSchedule with different time values:");
testData.forEach(data => {
  console.log(`\nAutomation: ${data.title}`);
  console.log(`Input time: ${data.scheduleTime}`);
  console.log(`Formatted: ${formatSchedule(data)}`);
});

// Export a runTests function that we can call from elsewhere
export function runFormatTests() {
  console.log("Running format tests...");
  testData.forEach(data => {
    console.log(`\nAutomation: ${data.title}`);
    console.log(`Input time: ${data.scheduleTime}`);
    console.log(`Formatted: ${formatSchedule(data)}`);
  });
}

// Call runTests immediately if this file is imported
runFormatTests(); 